import PropTypes from "prop-types";
import classnames from "classnames";

import Skeleton from "shared/components/Skeleton";

import "shared/components/PremiumDisplay/styles.scss";


function PremiumDisplay({premium, className, ...props}) {
    if (!premium) {
        return <div className={classnames("PremiumDisplay", className)} {...props}>
            <Skeleton className={"PremiumDisplay__Amount"}/>
            <Skeleton className={"PremiumDisplay__Period"}/>
        </div>
    }

    const {amount, period} = premium;
    const amountUnits = Math.floor(amount);
    const amountCents = (Math.floor((amount - amountUnits) * 100) + "00").substring(0, 2);
    return <div className={classnames("PremiumDisplay", className)} {...props}>
        <span className={"PremiumDisplay__Sign"}>$</span>
        <span className={"PremiumDisplay__Amount"}>{amountUnits.toLocaleString('en-US')}</span>
        <span className={"PremiumDisplay__Cents"}>.{amountCents}</span>
        <span className={"PremiumDisplay__Period"}>{period}</span>
    </div>;
}

PremiumDisplay.propTypes = {
    premium: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        period: PropTypes.string.isRequired,
    }),
};

export default PremiumDisplay;
